module.exports = __webpack_public_path__ + "img/soccer-background-mobile.c2ee44c8.png";